import { Component } from '@angular/core';
import { UsuariosService } from '../../../services/module-config/users/usuarios.service';

@Component({
  selector: 'app-update-contact-info',
  standalone: false,
  templateUrl: './update-contact-info.component.html',
  styleUrls: ['./update-contact-info.component.css'],
})
export class UpdateContactInfoComponent {
  search = '';
  users: any[] = [];
  selectedUser: any = null;
  cedula = '';

  personalEmail = '';
  phone = '';

  loadingSearch = false;
  saving = false;

  message = '';
  error = '';

  constructor(private usuariosService: UsuariosService) {}

  searchUsers(): void {
    this.message = '';
    this.error = '';
    this.selectedUser = null;
    this.users = [];

    const cleanSearch = this.search.trim();

    if (cleanSearch.length < 3) {
      this.error = 'Ingrese al menos 3 caracteres para buscar su nombre.';
      return;
    }

    this.loadingSearch = true;

    this.usuariosService
      .publicSearchUsersForContactUpdate(cleanSearch)
      .subscribe({
        next: (res) => {
          this.users = res?.data || [];

          if (this.users.length === 0) {
            this.error = 'No se encontraron usuarios con ese nombre.';
          }
        },
        error: (err) => {
          this.error =
            err?.error?.error ||
            err?.error?.message ||
            'No se pudo realizar la búsqueda.';
        },
        complete: () => {
          this.loadingSearch = false;
        },
      });
  }

  selectUser(user: any): void {
    this.selectedUser = user;
    this.message = '';
    this.error = '';
  }

  save(): void {
    this.message = '';
    this.error = '';

    if (!this.selectedUser?.external_id) {
      this.error = 'Seleccione su nombre antes de continuar.';
      return;
    }

    const cleanEmail = this.personalEmail.trim().toLowerCase();
    const cleanPhone = this.phone.trim();

    if (!cleanEmail) {
      this.error = 'Ingrese su correo personal.';
      return;
    }

    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(cleanEmail)) {
      this.error = 'Ingrese un correo personal válido.';
      return;
    }

    if (!cleanPhone) {
      this.error = 'Ingrese su número celular.';
      return;
    }

    if (!/^\d{7,15}$/.test(cleanPhone)) {
      this.error =
        'El celular debe contener solo números, entre 7 y 15 dígitos.';
      return;
    }

    this.saving = true;
    const cleanCedula = this.cedula.trim();

    if (!cleanCedula) {
      this.error = 'Ingrese su número de cédula.';
      return;
    }

    if (!/^\d{10,13}$/.test(cleanCedula)) {
      this.error = 'Ingrese una cédula válida.';
      return;
    }

    this.usuariosService
      .publicUpdateUserContactInfo(this.selectedUser.external_id, {
        personal_email: cleanEmail,
        phone: cleanPhone,
        cedula: cleanCedula,
      })
      .subscribe({
        next: () => {
          this.message =
            'Datos agregados correctamente. Gracias por actualizar su información.';
          this.error = '';
          this.users = [];
          this.search = '';
          this.personalEmail = '';
          this.phone = '';
          this.cedula = '';
        },
        error: (err) => {
          this.error =
            err?.error?.error ||
            err?.error?.message ||
            'No se pudo guardar la información.';
        },
        complete: () => {
          this.saving = false;
        },
      });
  }

  clearSelection(): void {
    this.selectedUser = null;
    this.personalEmail = '';
    this.phone = '';
    this.message = '';
    this.error = '';
  }
}
